import React, {Component} from 'react'
import moment from 'moment';
import {connect} from 'react-redux'
import action from '../helper/action'
import do_action from '../action'
import {Form, FormGroup} from '../component/form/form'
import {Portlet, PortletHead, PortletBody, PortletFooter, PortletAlert} from '../component/widget/portlet'
import {
  Link,
  withRouter
} from "react-router-dom"
import apis from '../helper/api'
import localdata from '../helper/localdata'
import config from '../helper/config'
import swal from 'sweetalert'
import util from '../helper/util'
import request from 'superagent'
import {history} from '../helper/history'
import {DatePicker, DatePickerInput} from 'rc-datepicker'

let photo_default = "../../swipe/assets/app/media/img/users/default.jpg"

class MasterCreateAgent extends Component {
    constructor(props) {
        super(props)
        this.state = {alert_message:"",flag_processing:false,email:"",username:"",user_id:"",
            identitas:[{name:"KTP"},{name:"SIM"},{name:"PASSPORT"},{name:"OTHER"}],
            sel_identitas:"",identitas_nomer:"",nomor_npwp:"",uploaded_identitas:false,
            sel_gender:"",i_tanggal_lahir:"",foto_diri:"",foto_identitas:"",
            name_full:"",fax:"",tempat_lahir:"",tanggal_lahir:"",pekerjaan:"",
            propinsi:"",propinsi_nama:"",kota:"",kota_nama:"",kecamatan:"",kecamatan_nama:"",kelurahan:"",
            kelurahan_nama:"",alamat:"",kode_pos:"",sel_gender:"",
            list_propinsi:[],list_kota:[],list_kecamatan:[],list_kelurahan:[],confirm_new_password:"",
            new_password:"",type_input_password: 'password', agent_downline: "",data_downline:[],nomor_telepon:""}
            this.on_btn_submit = this.on_btn_submit.bind(this)
            this.birth_date_change = this.birth_date_change.bind(this)
            this.reset = this.reset.bind(this)
    }

    reset() {
        this.setState({email:"",username:"",sel_identitas:"",identitas_nomer:"",nomor_npwp:"",sel_gender:"",i_tanggal_lahir:"",name_full:"",email:"",fax:"",tempat_lahir:"",tanggal_lahir:"",pekerjaan:"",
            propinsi:"",propinsi_nama:"",kota:"",kota_nama:"",kecamatan:"",kecamatan_nama:"",kelurahan:"",
            kelurahan_nama:"",alamat:"",kode_pos:"",sel_gender:"",confirm_new_password:"",
            new_password:"",type_input_password: 'password',agent_downline: "",nomor_telepon:""})
    }

    componentDidMount() {
        this.props.update_current_page('manage-agent')
        this.load_provinsi()
        this.get_master_downline()
    }

    load_provinsi() {
        let self = this
        request.get(apis.list_propinsi).end((err, res) => {
            if (err) {
                util.log("error: " + err);
            } else {
                util.log(res);
                if (res.status == 200) {
                    const data = JSON.parse(res.text)
                    if (data.status == "OK") {
                        let list = data.results.list
                        let t = []
                        list.map(item =>
                            t.push({'province_id' : item.province_id, 'province_name' : item.province_name})
                        )
                        self.setState({list_propinsi: t})
                    }
                }
            }
        })
    }

    get_master_downline() {
        let body = {
            "session_id" : this.props.session
        }
        let self = this
        request.post(apis.list_downline)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK") {
                            self.setState({data_downline: {data: payload.results.list, next: payload.results.next_page}})
                        }
                    }
                }
            })
    }

    birth_date_change(date) {
        try {
            util.log(date)
            let onlyDate = ''
            if (date.length !== 0) {
                let bulan = (date.getMonth() + 1).toString()
                let hari = date.getDate().toString()
                let m = bulan.length === 1 ? '0' + bulan : bulan
                let h = hari.length === 1 ? '0' + hari : hari
                onlyDate = date.getFullYear() + "-" + m + "-" + h
            }
            util.log(onlyDate)
            this.setState({tanggal_lahir : onlyDate, i_tanggal_lahir : date});
        } catch(err) {
            util.log("[end_date_change] error", err)
        }
    }

    on_select_change(e) {
        let self = this
        const {options, selectedIndex} = e.target
        util.log(e.target.id, e.target.value, options[selectedIndex].innerHTML)
        if (e.target.id === 'propinsi-sel') {
            self.setState({list_kota: [], list_kecamatan: [], list_kelurahan: [], propinsi: e.target.value, propinsi_nama: options[selectedIndex].innerHTML})
            if (e.target.value.length !== 0) {
                let url = apis.list_kota.replace("{provinsi_id}", e.target.value)
                request.get(url).end((err, res) => {
                    if (err) {
                        util.log("error: " + err);
                    } else {
                        util.log(res);
                        if (res.status == 200) {
                            const data = JSON.parse(res.text)
                            if (data.status == "OK") {
                                let list = data.results.list
                                let t = []
                                list.map(item =>
                                    t.push({'city_id' : item.city_id, 'city_name' : item.city_name})
                                )
                                self.setState({list_kota: t})
                            }
                        }
                    }
                })
            }
        } else if (e.target.id === 'kota-sel') {
            self.setState({list_kecamatan: [], list_kelurahan: [], kota: e.target.value, kota_nama: options[selectedIndex].innerHTML})
            if (e.target.value.length !== 0) {
                let url = apis.list_district.replace("{provinsi_id}", self.state.propinsi).replace("{kota_id}", e.target.value)
                request.get(url).end((err, res) => {
                    if (err) {
                        util.log("error: " + err);
                    } else {
                        util.log(res);
                        if (res.status == 200) {
                            const data = JSON.parse(res.text)
                            if (data.status == "OK") {
                                let list = data.results.list
                                let t = []
                                list.map(item =>
                                    t.push({'district_id' : item.district_id, 'district_name' : item.district_name})
                                )
                                self.setState({list_kecamatan: t})
                            }
                        }
                    }
                })
            }
        } else if (e.target.id === 'kecamatan-sel') {
            self.setState({list_kelurahan: [], kecamatan: e.target.value, kecamatan_nama: options[selectedIndex].innerHTML})
            if (e.target.value.length !== 0) {
                let url = apis.list_village.replace("{provinsi_id}", self.state.propinsi).replace("{kota_id}", self.state.kota).replace("{district_id}", e.target.value)
                request.get(url).end((err, res) => {
                    if (err) {
                        util.log("error: " + err);
                    } else {
                        util.log(res);
                        if (res.status == 200) {
                            const data = JSON.parse(res.text)
                            if (data.status == "OK") {
                                let list = data.results.list
                                let t = []
                                list.map(item =>
                                    t.push({'village_id' : item.village_id, 'village_name' : item.village_name})
                                )
                                self.setState({list_kelurahan: t})
                            }
                        }
                    }
                })
            }
        } else if (e.target.id === 'kelurahan-sel') {
            self.setState({kelurahan: e.target.value, kelurahan_nama: options[selectedIndex].innerHTML})
        } else if (e.target.id === 'gender-sel') {
            self.setState({sel_gender: e.target.value})
        } else if (e.target.id === 'identitas-sel') {
            self.setState({sel_identitas: e.target.value})
        } else {
            self.setState({[e.target.id]: e.target.value})
        }
    }

    on_error(err) {
        if (err.code == 2006) {
            localdata.clear_data().then((res) => {
                history.replace('/login')
            }).catch((err) => {
                util.log("error: ", err)
            })
        } else {
            let msg = "Error: " + err.code
            if (err.message !== undefined) {
                msg = err.message
            }
            swal("Ups!", msg, "warning")
        }
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_btn_submit() {
        let valid = true
        if (this.state.name_full.length === 0) {
            valid = false
        }

        if (this.state.identitas_nomer.length === 0) {
            valid = false
        }

        if (this.state.sel_identitas.length === 0) {
            valid = false
        }

        if (!valid) {
            swal("Ups!", "Bagian Kartu Identitas Anda Wajib Ada", "warning")
            return
        }

        if (this.state.new_password !== this.state.confirm_new_password) {
            swal("Ups!", "Password dan Konfirm Password tidak sama", "warning")
            return
        }

        if (this.state.email.length === 0) {
            swal("Ups!", "Email agent harus ada", "warning")
            return
        }

        let self = this
        let username = self.state.nomor_telepon
        if (username.startsWith("0")) {
            username = username.substring(1, username.length)
            username = "62" + username 
        }
        let body = {
            "session_id": this.props.session,
            "username": username,
            "password": self.state.new_password,
            "fullname": self.state.name_full,
            "profile": {
                "email": self.state.email,
                "phone_number": self.state.nomor_telepon,
                "place_birth": self.state.tempat_lahir,
                "birth_date": self.state.tanggal_lahir,
                "gender": self.state.sel_gender,
                "npwp_number": self.state.nomor_npwp,
                "province_name": self.state.propinsi_nama,
                "city_name": self.state.kota_nama,
                "district_name": self.state.kecamatan_nama,
                "village_name": self.state.kelurahan_nama,
                "address": self.state.alamat,
                "postal_code": self.state.kode_pos,
                "job_title": self.state.pekerjaan,
                "id_card_type": self.state.sel_identitas,
                "id_card_number": self.state.identitas_nomer
            }
        }
        let url = apis.create_my_agent
        if (self.state.agent_downline.length !== 0) {
            url = apis.create_agent_of_downline.replace("{master_id}", self.state.agent_downline)
        }
        self.setState({flag_processing: true})
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let message_result = ""
                let success_result = ""
                if (err || !res.ok) {
                    util.log(err)
                    message_result = {title: "Error", body: err.message}
                    if (res != undefined) {
                        message_result.body = "Error code " + res.statusCode
                    }
                } else {
                    util.log(res);
                    if (res.statusCode === 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status === "OK") {
                            self.setState({flag_processing: false})
                            swal(payload.error.message, payload.display_message, "success")
                            self.reset()
                            return
                        } else {
                            message_result = {title: "Error", body: res.body.error.message}
                            if (res.body.display_message !== undefined) {
                                message_result = {title: payload.error.message, body: payload.display_message}
                            }
                            self.on_error(payload)
                        }
                    } else {
                        message_result = {title: "Error", body: res.statusCode}
                    }
                }
                if (message_result.length !== 0) {
                    swal(message_result.title, message_result.body, "warning")
                }
                self.setState({flag_processing: false})
            });
    }

    on_show_hide_password(e) {
        if (this.state.type_input_password === 'password') {
            this.setState({type_input_password: 'text'})
        } else {
            this.setState({type_input_password: 'password'})
        }
    }

    render() {
        let self = this
        return (
            <div className="row">
                <div className="col-md-12">
                    {this.state.alert_message.length !== 0 ? <PortletAlert icon="warning" title={this.state.alert_message.title} message={this.state.alert_message.body} /> : ""}
                    <Portlet>
                        <PortletHead headTxt={"Buat Agent Baru"} />
                        <PortletBody>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="">
                                        <div className="m-card-profile__pic">
                                            <div className="m-card-profile__pic-wrapper" style={{textAlign: 'center'}}>
                                                <img src={photo_default} style={{width:100+'px',height:100+'px'}}/>
                                            </div>
                                        </div>
                                        <div style={{margin: '20px 10px'}}>
                                            <div className="form-group m-form__group row">
                                                <div className="col-10">
                                                    <h3 className="m-form__section">
                                                        1. Kartu Identitas
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Tipe Kartu Identitas
                                                </label>
                                                <div className="col-9" style={{margin: 'auto 0'}}>
                                                    <select className={this.state.sel_identitas.length === 0 ? "form-control m-input border-red" : "form-control m-input"} id="identitas-sel" value={this.state.sel_identitas} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                        <option key={999} value=""> -- Pilih -- </option>
                                                        {
                                                            self.state.identitas.length != 0 ? self.state.identitas.map((p, i) =>
                                                                <option key={i} value={p.name}>
                                                                    {p.name}
                                                                </option>
                                                            ) : ''
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Nomor Kartu Identitas
                                                </label>
                                                <div className="col-9" style={{margin: 'auto 0'}}>
                                                    <input className="form-control m-input" type="text" 
                                                        name="identitas_nomer"
                                                        onChange={(e) => this.on_input_change(e)}
                                                        value={this.state.identitas_nomer}/>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Nama Lengkap
                                                </label>
                                                <div className="col-9" style={{margin: 'auto 0'}}>
                                                    <input className="form-control m-input" 
                                                    name="name_full"
                                                    type="text" 
                                                    onChange={(e) => this.on_input_change(e)}
                                                    value={this.state.name_full}/>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Downline Dari
                                                </label>
                                                <div className="col-lg-9" style={{margin: 'auto 0'}}>
                                                    <select id="agent_downline" name="agent_downline" className="form-control m-input" value={this.state.agent_downline} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                        <option key={999} value="">-- Agent Saya --</option>
                                                        {
                                                            self.state.data_downline.length != 0 ? self.state.data_downline.data.map((item, i) =>
                                                                <option key={i} value={item.master_agent_id}>
                                                                    {item.fullname}
                                                                </option>
                                                            ) : ''
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="" style={{marginTop: '30px'}}></div>
                                            <div className="form-group m-form__group row">
                                                <div className="col-10">
                                                    <h3 className="m-form__section">
                                                        2. Personal Info
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Telepon
                                                </label>
                                                <div className="col-9">
                                                    <input className="form-control m-input" type="text" 
                                                    name="nomor_telepon"
                                                    onChange={(e) => this.on_input_change(e)}
                                                    value={this.state.nomor_telepon}/>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Password
                                                </label>
                                                <div className="col-9 m-input-icon m-input-icon--right" style={{paddingRight:'15px',paddingLeft:'15px'}}>
                                                    <input className="form-control m-input" 
                                                        name="new_password"
                                                        type={this.state.type_input_password} 
                                                        onChange={(e) => this.on_input_change(e)}
                                                        value={this.state.new_password}/>
                                                        <span className="m-input-icon__icon m-input-icon__icon--right" style={{width: '4rem',paddingRight:'15px'}}>
                                                            <span onClick={(e) => this.on_show_hide_password(e)}>
                                                                <i className={this.state.type_input_password === 'password' ? 'la la-eye' : 'la la-eye-slash'}></i>
                                                            </span>
                                                        </span>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Konfirm Password
                                                </label>
                                                <div className="col-9 m-input-icon m-input-icon--right" style={{paddingRight:'15px',paddingLeft:'15px'}}>
                                                    <input className="form-control m-input" 
                                                        type={this.state.type_input_password} 
                                                        name="confirm_new_password"
                                                        onChange={(e) => this.on_input_change(e)}
                                                        value={this.state.confirm_new_password}/>
                                                    <span className="m-input-icon__icon m-input-icon__icon--right" style={{width: '4rem',paddingRight:'15px'}}>
                                                        <span onClick={(e) => this.on_show_hide_password(e)}>
                                                            <i className={this.state.type_input_password === 'password' ? 'la la-eye' : 'la la-eye-slash'}></i>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    NPWP
                                                </label>
                                                <div className="col-9">
                                                    <input className="form-control m-input" type="text" 
                                                    name="nomor_npwp"
                                                    onChange={(e) => this.on_input_change(e)}
                                                    value={this.state.nomor_npwp}/>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Email
                                                </label>
                                                <div className="col-9">
                                                    <input className="form-control m-input" type="text" 
                                                    name="email"
                                                    onChange={(e) => this.on_input_change(e)}
                                                    value={this.state.email}/>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Jenis Kelamin
                                                </label>
                                                <div className="col-9">
                                                    <select className="form-control m-input" id="gender-sel" value={this.state.sel_gender} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                        <option key={999} value=""> -- Pilih -- </option>
                                                        <option key={0} value="M">Laki-Laki</option>
                                                        <option key={1} value="F">Perempuan</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Fax
                                                </label>
                                                <div className="col-9">
                                                    <input className="form-control m-input" type="text" 
                                                        name="fax"
                                                        onChange={(e) => this.on_input_change(e)}
                                                        value={this.state.fax}/>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Tempat Lahir
                                                </label>
                                                <div className="col-9">
                                                    <input className="form-control m-input" type="text" 
                                                        name="tempat_lahir"
                                                        onChange={(e) => this.on_input_change(e)}
                                                        value={this.state.tempat_lahir}/>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Tanggal Lahir
                                                </label>
                                                <div className="col-9">
                                                    <DatePickerInput onChange={this.birth_date_change} value={this.state.i_tanggal_lahir}/>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Pekerjaan
                                                </label>
                                                <div className="col-9">
                                                    <input className="form-control m-input" type="text" 
                                                        name="pekerjaan"
                                                        onChange={(e) => this.on_input_change(e)}
                                                        value={this.state.pekerjaan}/>
                                                </div>
                                            </div>
                                            <div className="" style={{marginTop: '30px'}}></div>
                                            <div className="form-group m-form__group row">
                                                <div className="col-10">
                                                    <h3 className="m-form__section">
                                                        3. Alamat Domisili
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Provinsi
                                                </label>
                                                <div className="col-9">
                                                    <select className="form-control m-input" id="propinsi-sel" value={this.state.propinsi} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                        <option key={999} value=""> -- Pilih Provinsi -- </option>
                                                        {
                                                            self.state.list_propinsi.length != 0 ? self.state.list_propinsi.map((item, i) =>
                                                                <option key={i} value={item.province_id}>
                                                                    {item.province_name}
                                                                </option>
                                                            ) : ''
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Kota
                                                </label>
                                                <div className="col-9">
                                                    <select className="form-control m-input" id="kota-sel" value={this.state.kota} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                        <option key={999} value=""> -- Pilih Kota -- </option>
                                                        {
                                                            self.state.list_kota.length != 0 ? self.state.list_kota.map((item, i) =>
                                                                <option key={i} value={item.city_id}>
                                                                    {item.city_name}
                                                                </option>
                                                            ) : ''
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Kecamatan
                                                </label>
                                                <div className="col-9">
                                                    <select className="form-control m-input" id="kecamatan-sel" value={this.state.kecamatan} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                        <option key={999} value=""> -- Pilih Kecamatan -- </option>
                                                        {
                                                            self.state.list_kecamatan.length != 0 ? self.state.list_kecamatan.map((item, i) =>
                                                                <option key={i} value={item.district_id}>
                                                                    {item.district_name}
                                                                </option>
                                                            ) : ''
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Kelurahan
                                                </label>
                                                <div className="col-9">
                                                    <select className="form-control m-input" id="kelurahan-sel" value={this.state.kelurahan} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                        <option key={999} value=""> -- Pilih Kelurahan -- </option>
                                                        {
                                                            self.state.list_kelurahan.length != 0 ? self.state.list_kelurahan.map((item, i) =>
                                                                <option key={i} value={item.village_id}>
                                                                    {item.village_name}
                                                                </option>
                                                            ) : ''
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Alamat Lengkap
                                                </label>
                                                <div className="col-9">
                                                    <input className="form-control m-input" type="text" 
                                                        name="alamat"
                                                        onChange={(e) => this.on_input_change(e)}
                                                        value={this.state.alamat}/>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                                    Kode Pos
                                                </label>
                                                <div className="col-9">
                                                    <input className="form-control m-input" type="text" 
                                                    name="kode_pos"
                                                    onChange={(e) => this.on_input_change(e)}
                                                    value={this.state.kode_pos}/>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="m-portlet__foot m-portlet__foot--fit m-portlet__no-border" style={{marginTop:'40px'}}>
                                            <div className="m-form__actions">
                                                <div className="row">
                                                    <div className="col-7">
                                                        <button type="reset" 
                                                            onClick={this.on_btn_submit} 
                                                            className={this.state.flag_processing ? 'btn btn-accent m-btn m-btn--air m-btn--custom m-loader m-loader--light m-loader--right' : 'btn btn-accent m-btn m-btn--air m-btn--custom'}>
                                                            Submit Agent Baru
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>

                                </div>
                            </div>
                        </PortletBody>
                    </Portlet>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    update_current_page:  val => dispatch(do_action(action.ACTION_UPDATE_CURRENT_PAGE, val)),
    loading: val => dispatch(do_action(action.ACTION_LOADING), val)
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(MasterCreateAgent)



// WEBPACK FOOTER //
// ./src/component/magent_create_new_agent.js